import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@app/contexts/AuthContext';
import { toast } from 'react-toastify';

/**
 * Hook to handle token expiration
 * Shows a toast notification and redirects to login when token expires
 */
export const useTokenExpiration = () => {
    const { tokenExpired, logout } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (tokenExpired) {
            // Show notification
            toast.warning('Your session has expired. Please login again.', {
                position: 'top-right',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });

            // Logout and redirect
            logout();
            setTimeout(() => {
                navigate('/login');
            }, 1000);
        }
    }, [tokenExpired, logout, navigate]);
};

export default useTokenExpiration;
